module.exports = __webpack_public_path__ + "img/datingforparents.4eaac58.png";